import React from 'react';

import { usePaginatedTasks } from '../hooks/usePaginatedTasks';
import TaskSection from './TaskSection';

const PaginatedTaskSection = ({
    token,
    fetchTasks,
    scope = 'active',
    assignedToMe = false,
    hydrateTask,
    refreshSignal = 0,
    pageSize = 15,
    title,
    description,
    emptyMessage,
    renderTask,
    framed = false,
    showStatusFilter = true,
    layout = 'list',
    searchPlaceholder = 'Search by Task ID, title, description, or assignee…',
}) => {
    const {
        items,
        pagination,
        search,
        setSearch,
        statusFilter,
        setStatusFilter,
        loading,
        error,
        loadPage,
    } = usePaginatedTasks({
        token,
        fetchTasks,
        scope,
        assignedToMe,
        hydrateTask,
        refreshSignal,
        pageSize,
    });

    return (
        <TaskSection
            title={title}
            description={description}
            items={items}
            emptyMessage={emptyMessage}
            framed={framed}
            renderTask={renderTask}
            showStatusFilter={showStatusFilter}
            layout={layout}
            serverSideFilter
            search={search}
            onSearchChange={setSearch}
            searchPlaceholder={searchPlaceholder}
            statusFilter={statusFilter}
            onStatusFilterChange={setStatusFilter}
            pagination={pagination}
            onPageChange={loadPage}
            loading={loading}
            error={error}
        />
    );
};

export default PaginatedTaskSection;
